import L from "leaflet";

// owner
import { forceMapFilters } from "@/components/AdvancedFilters/FilterConstants";
import { ClusterIcon } from "@/components/Leaflet/Map/Marker/ClusterIcon";
import { ICON_TYPE, svgIcon } from "@/components/Leaflet/Map/Marker/SvgIcon";
import {
  PruneCluster,
  PruneClusterForLeaflet,
} from "@/components/Leaflet/Map/PruneCluster/PruneCluster";
import GlobalUtils from "@/utils/GlobalUtils";

import searchUIClient from "@/apis/searchUIClient";
import DeviceIcon from "@images/device/Device-icon.svg";
import Cluster_Icon from "@images/map/cluster-icon.svg";
import configurationUtils from "@/utils/IconConfiguration";

L.AssetLayer = L.FeatureGroup.extend({
  options: {},
  bounds: L.latLngBounds(),
  pruneCluster: null,

  disableGroup: function (isDisabled) {
    var self = this;
    if (self.pruneCluster) {
      if (isDisabled) {
        self.pruneCluster.Cluster.Size = 0.0000000001;
      } else {
        self.pruneCluster.Cluster.Size = 87;
      }
      self.pruneCluster.ProcessView();
    }
  },
  updateData: function (orgId) {
    var self = this;
    let pruneCluster = new PruneClusterForLeaflet(10, 10);

    self.pruneCluster = pruneCluster;
    PruneCluster.Cluster.ENABLE_MARKERS_LIST = true;
    pruneCluster.BuildLeafletClusterIcon = function (cluster) {
      let _length = cluster.population;
      return ClusterIcon({
        count: _length,
        iconUrl: Cluster_Icon,
        iconClassName: "cluster-svg",
      });
    };
    pruneCluster.PrepareLeafletMarker = function (leafletMarker, data) {
      data.icon.setMarker(leafletMarker);
      leafletMarker.setIcon(data.icon);
      if (data.tooltip) {
        leafletMarker.unbindTooltip();
        leafletMarker.bindTooltip(data.tooltip, {
          permanent: true,
          direction: "top",
          className: "transparent-tooltip",
          offset: [0, -8],
        });
      }
    };

    let basic = {
      searchQueryType: "BASIC",
      queryObjectType: "SIGFOX_DEVICE",
      query: [],
      requestedTableColumns: [
        {
          columnKey: "lastNetworkLocationRadius",
          order: null,
        },
        {
          columnKey: "currentLat",
          order: null,
        },
        {
          columnKey: "currentLng",
          order: null,
        },
        {
          columnKey: "name",
          order: null,
        },
        {
          columnKey: "decoratorColor",
          order: null,
        },
        {
          columnKey: "location",
          order: null,
        },
        {
          columnKey: "lastBeaconName",
          order: null,
        },
        {
          columnKey: "lastActivity",
          order: null,
        },
      ],
    };

    if (orgId)
      basic.query.push({
        categoryId: "userInfo",
        filterKey: "organizations",
        filterType: "MULTI_SELECT_AUTO_COMPLETE",
        searchType: "STATIC",
        notFilter: false,
        filterValue: {
          includeEmpty: false,
          includeNoEmpty: false,
          selectedValues: [orgId],
        },
      });
    forceMapFilters(basic);

    self.bound = L.latLngBounds();
    self.clearLayers();

    self.addLayer(self.pruneCluster);

    searchUIClient.search(basic).then(({ data }) => {
      self.processData(data.data);
    });
  },
  transformData: function (beacon) {
    beacon.coordinate = {
      lat: beacon.currentLat,
      lon: beacon.currentLng,
      lastSeen: beacon.lastSeenAlive,
    };
  },
  isValidCoordinate: function (coordinate) {
    return !!(coordinate && (coordinate.lat || coordinate.lon));
  },
  processData: function (data) {
    let self = this;
    let lastMarkers = [];
    data.forEach((obj) => {
      self.transformData(obj);
      let coordinate = obj.coordinate,
        isValid = self.isValidCoordinate(coordinate);
      if (isValid) {
        lastMarkers.push(obj);
      }
    });
    self.processMarkers(lastMarkers);
  },
  processMarkers: function (lastMarkers) {
    let self = this;
    var markersById = new Map(lastMarkers.map((m) => [m.id, m]));

    // register the remaining markers
    markersById.forEach((device) => {
      // new marker, add to cluster
      let _coordinate = device.coordinate;
      let activityState = configurationUtils.getActivityState(device);
      let state = configurationUtils.getState(device);
      let highestSeverity = configurationUtils.getHighestAlertSeverity(device);

      let icon = svgIcon({
        iconUrl: device.trackerIcon
          ? GlobalUtils.getFile(
              "device",
              device.id,
              "icon",
              device.trackerIcon,
              "small"
            )
          : DeviceIcon,
        id: device.id,
        trackerName: device.name,
        activityState: activityState,
        state: state,
        network: device?.lastLocationSource === "network",
        alertSeverity: highestSeverity,
        decoratorColor: device?.decoratorColor,
        type: ICON_TYPE.assetType,
      });

      let marker = new PruneCluster.Marker(
        _coordinate.lat || 0,
        _coordinate.lon || 0,
        {
          icon: icon,
          tooltip: device.name,
        }
      );
      marker.data.deviceInfo = device;
      marker.getLatLng = function () {
        return new L.latLng(this.position.lat, this.position.lon);
      };

      // calculatedBounds.current.extend(L.latLng(_coordinate.lat, _coordinate.lon));
      self.pruneCluster.RegisterMarker(marker);
    });

    self.pruneCluster.ProcessView();
  },

  getLayer: function () {
    return this;
  },
  getBounds: function () {
    return this.bounds;
  },
});

L.assetLayer = function (opts) {
  return new L.AssetLayer(opts);
};
export const AssetLayer = L.assetLayer;
